"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdditionalInfo = void 0;
var _icons = require("@ori-ui/icons");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _hooks = require("../../hooks");
var _types = require("../../types");
var _AccountBalanceDialog = require("../AccountBalanceDialog");
var _VouchersDialog = require("../VouchersDialog");
var _styles = require("./styles");
var _useAdditionalInfo = require("./useAdditionalInfo");
var _jsxRuntime = require("react/jsx-runtime");
const AdditionalInfo = ({
  customerId,
  sessionId
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _hooks.useTranslations)();
  const {
    shoppingContext: {
      isAnonymous,
      shoppingBag: {
        balanceBefore: {
          credit = '',
          discount = '',
          groupBp = '',
          personalBp = ''
        } = {},
        isAccountBalanceVisible
      } = {},
      showBp
    } = {}
  } = (0, _shoppingContext.useShoppingContext)();
  const {
    isVouchersDialogOpen,
    isBalanceDialogOpen,
    onAccountBalanceClick,
    toggleVouchersDialog,
    toggleBalanceDialog
  } = (0, _useAdditionalInfo.useAdditionalInfo)();
  const isBpVisible = Boolean(showBp && (personalBp || groupBp));
  const isWalletVisible = Boolean(isAccountBalanceVisible && discount);
  const isCreditAvailable = Boolean(credit);
  const isAccountBalanceItemVisible = !isAnonymous && (isCreditAvailable || isBpVisible || isWalletVisible);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      "data-testid": getTestId(_types.TestId.AdditionalInfo),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AdditionalItem, {
        onClick: toggleVouchersDialog,
        children: [formatMessage('addVoucher'), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})]
      }), isAccountBalanceItemVisible ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Separator, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AdditionalItem, {
          onClick: onAccountBalanceClick,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.AccountBalanceTitle, {
            children: [isCreditAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AccountBalanceItem, {
              children: formatMessage('credit')
            }) : null, isBpVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AccountBalanceItem, {
              children: formatMessage('bonusPoints')
            }) : null, isWalletVisible ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AccountBalanceItem, {
              children: formatMessage('wallet')
            }) : null]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.ArrowRightThin, {})]
        })]
      }) : null]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_VouchersDialog.VouchersDialog, {
      customerId: customerId,
      isVouchersDialogOpen: isVouchersDialogOpen,
      sessionId: sessionId,
      onClose: toggleVouchersDialog
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccountBalanceDialog.AccountBalanceDialog, {
      isBalanceDialogOpen: isBalanceDialogOpen,
      toggleBalanceDialog: toggleBalanceDialog
    })]
  });
};
exports.AdditionalInfo = AdditionalInfo;